module.exports = __webpack_public_path__ + "static/media/Felix@2x.03c8c350.png";